//var $ = require('jquery'), jQuery = $

var getGlobal = function (iCurrent) {
  if (iCurrent) {
    return Global;
  }

  fConfig = {
    Behavior: {
      echoTest: false,
      echoLevel: 0
    },
    Display: {
      Frames: {},
      Current: null,
      Root: null
    },
    Server: {
      Status: true,
      REST: "/json.aspx"
    },
    Session: {
      Status: false,
      Id: 0,
      UID: '',
      UserId: 0,
      UserUID: "visitor",
      UserAuth: false,
      UserName: "Anonimus",
      InfoId: 0,
      InfoKey: "",
      InfoUID: "",
      InfoName: "Anonimus"
    },
    CacheData: {

    },
    Callbacks: {

    },
    Variables: {
      CacheExpireMSec: 60000,
      PingInterval: 120000,
      CreateDate: (new Date()).toISOString().substring(0, 19).replace('T', ' ')
    },
    Config: {
      DisplayId: "list",
      DisplayFrame: "home",
      DisplayHome: "menu",
      BugREST: "https://nte.in.rs/json.aspx",
      BugHelp: "https://nte.in.rs/help.html#app?",
      OneTabOneSession: true,
      FirstLocal: true,
      Offline: false
    }
  };

  if (typeof (ConfigClient) == "object") {
    var mergeArray = function (iA, iB) {
      var fResult = iA;
      try {
        fResult = Object.assign(iA, iB);
      } catch (err) {
        for (var key in iB) {
          iA[key] = iB[key];
        }
      }

      return fResult;
    }
    fConfig.Behavior = mergeArray(fConfig.Behavior, ConfigClient.Behavior);
    fConfig.Variables = mergeArray(fConfig.Variables, ConfigClient.Variables);
    fConfig.Config = mergeArray(fConfig.Config, ConfigClient.Config);
    if(ConfigClient.Server&&ConfigClient.Server.REST){
      fConfig.Server.REST = ConfigClient.Server.REST;
    }
    if(ConfigClient.Access&&typeof(ConfigClient.Access.OneTabApp)==="boolean"){
      fConfig.Config.OneTabOneSession = ConfigClient.Access.OneTabApp
    }
  }

  return fConfig;
}
var fConfig = ((typeof (Global) !== "undefined") && (Global) && (Global.Config)) ? Global.Config : getGlobal().Config;
var getConfig = function () {
  return Global.Config;
}
var createDisplay = function (iTab) {
  return {
    Tab: ((iTab) ? iTab : "home"),
    lClass: function () {
      var fTab = this.Tab;
      if (fTab == "home") {
        return "col-md-6 panel panel-body";
      } else {
        return "col-md-6 panel panel-body hidden-xs hidden-sm hidden-md";
      }
    },
    rClass: function () {
      var fTab = this.Tab;
      if (fTab == "home") {
        return "col-md-6 hidden-xs hidden-sm hidden-md";
      } else {
        return "col-md-6 ";
      }
    },
    isHome: function () {
      var fTab = this.Tab;
      return (fTab == "home");
    },
    isTab: function (iValue) {
      if (this.Tab == iValue) {
        return true;
      }
      var fTabs = iValue.split(',');
      for (i = 0; i < fTabs.length; i++) {
        if (this.Tab == fTabs[i]) {
          return true;
        }
      }

      return false;
    },
    isEdit: function (iValue, iTrue, iFalse) {
      var fResult = false;
      if (iValue) {
        if (0 <= iValue) {
          fResult = true;
          if (iTrue) {
            fResult = iTrue;
          }
        }
      } else {
        if ((!iValue) || ((iValue) && (JSON.stringify(iValue) == '{}'))) {
          fResult = false;
          if (iFalse) {
            fResult = iFalse;
          }
        }
      }

      return fResult;
    }
  }
}
var setDisplay = function (iViewName, iBehavior, iCallback) {
  var fElement;
  var fDisplay;

  if ((typeof (iViewName) == "object") && (iViewName.Frame)) {
    fElement = { el: iViewName.Id };
    iViewName.Frame = iViewName.Frame.toLowerCase();
    if(iViewName.Frame&&Ractive.components[iViewName.Frame]){
      fDisplay = Ractive.components[iViewName.Frame];
    }
    if ((typeof (fDisplay) == "undefined") || (!fDisplay)) {
      console.error('Error: Component not found!', iViewName);
      if(Ractive.components["404"]){
        fDisplay = Ractive.components["404"];
        Global.Display.Root = new fDisplay(fElement);
      }
      return;
    }    
    Global.Display.Current = new fDisplay(fElement);
    return;
  } else {
    fElement = { el: 'body' };
    if ((Global) && (Global.Config) && (Global.Config.DisplayId)) {
      fElement = { el: Global.Config.DisplayId };
    }
    iViewName = iViewName.toLowerCase();
    if(iViewName&&Ractive.components[iViewName]){
      fDisplay = Ractive.components[iViewName];
    }
  }

  if (isEcho()) console.log('Display:', fElement, iViewName, iBehavior);
  if ((typeof (fDisplay) == "undefined") || (!fDisplay)) {
    console.error('Error: Component not found!', iViewName);
    if(Ractive.components["404"]){
      fDisplay = Ractive.components["404"];
      Global.Display.Root = new fDisplay(fElement);
    }
    return;
  }
  Global.Display.Root = new fDisplay(fElement);

  if (iCallback) iCallback();
}
var setUrlResult = function (value, iCallback) {
  console.log('Pagevalue:', value);
  var fViewName = value.PageName;
  if (value.View) {
    /*
    rcu.init(Ractive);
    var a = rcu.parse(`<script>
      component.exports ={
        onrender: function ( options ) {
              var aa= 2 / 3;
          }
          ,computed:{
                paginationbuttons:function()
                    {
                        return 1/2;
                    }
            }
      }
      </script>`);
      */
    Display = Ractive.extend({ magic: true, template: value.View.Content });
    //Display = Ractive.parse(value.View.Content);
    //Display = Ractive.extend({ template: Ractive.parse(value.View.Content)});
    if (value.View.Cache) {
      Ractive.components[fViewName] = Display;
    }
  }
  else {
    Display = Ractive.components['404'];
  }

  Global.Display.Current = new Display({ el: 'List' })
}
var getBase64 = function (iValue) {
  if(iValue){
    try
    {
      var fValue = JSON.stringify(iValue);

      fValue = unescape(encodeURIComponent(fValue));
      fValue = btoa(fValue).toString().replace('==', '').replace('=', '').trim();
    
      return fValue;  
    }
    catch(err){

    }
  }

  return '';
}
var getIsValid = function (iValue, iType, iRegEx) {
  var fValue = (iValue) ? iValue : "";
  var fType = (iType) ? iType : "empty";
  var fRegEx = (iRegEx) ? iRegEx : "";
  var fResult = false;
  switch (fType) {
    case "empty":
      fResult = ((fValue) && (fValue.trim() != ""));
      break;
    case "min3":
      fResult = ((fValue) && (fValue.trim() != "") && (2 <= fValue.trim().length));
      break;
    case "min4":
      fResult = ((fValue) && (fValue.trim() != "") && (3 <= fValue.trim().length));
      break;
    case "min6":
      fResult = ((fValue) && (fValue.trim() != "") && (5 <= fValue.trim().length));
      break;
    case "email":
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      fResult = re.test(String(fValue).toLowerCase());
      break;
  }

  return fResult;
}
var goUrl = function (iHash, iData, iCallback) {
  var fUrl = "";
  fUrl += ((iHash && iHash[0] == "#") ? '' : '#') + iHash;
  if (iData) {
    fUrl += '?' + getBase64(iData);
  }
  window.location.href = fUrl;
  if (iCallback) iCallback();
}
var setUrlChange = function (iCallback, iRunOnce) {
  if ("onhashchange" in window) {
    window.onhashchange = iCallback || setUrl
  } else {
    window.setInterval(iCallback || setUrl, 500);
  };

  if (iRunOnce) {
    if (iCallback) {
      iCallback();
    } else {
      setUrl();
    }
  }
}
var setUrl = function (value, iCallback) {
  if ((!value || window.location.hash == "" || window.location.href.toString().endsWith('#')) && Global && Global.Config && Global.Config.DisplayHome) {
    value = "#" + Global.Config.DisplayHome;
  } else {
    value = window.location.hash;
  }
  if (isEcho()) console.log('setUrl:', value);
  if (value) {
    //var fUrl = value.toString();
    if (startsWith(value, '#')) {
      var fUrl = getUrl(value);

      Display = Ractive.components[fUrl.Page];
      if (isEcho()) console.log('Display:', fViewName, fUrl, Display);
      if (Display) {
        if (Global.Display.CurrentPage == fUrl.Page) {
          if (Global.Display.Current) {
            Global.Display.Current.fire("doUrl", fUrl);
          }
        } else {
          Global.Display.CurrentPage = fUrl.Page;
          var fEl = (Global.Config.DisplayId) ? Global.Config.DisplayId : 'List';
          if (Global.Display.Current) {
            try {
              delete (Global.Display.Current);
              Global.Display.Current = null;
            }
            catch (err) {
              console.log("Error delete current display:", err);
            }
          }
          if (isEcho()) console.log('Display:', fViewName, fEl);
          Global.Display.Current = new Display({ el: fEl });
        }
        if (iCallback) iCallback();
        if (typeof (runDesign) == "function") runDesign();
      } else {
        $("#List").html($("#ListLoading").html());

        var fMessage = { PageName: fViewName };
        ServerIO.iosocket.emit('Page', fMessage, setUrlResult);
        if (Display = Ractive.components["404"]) {
          var fEl = (Global.Config.DisplayId) ? Global.Config.DisplayId : 'List';
          Global.Display.Current = new Display({ el: fEl });
        }
      }
    }
  } else {
    if (Display = Ractive.components['Dashboard']) {
      Global.Display.Current = new Display({ el: 'List' });
    }

    if (iCallback) iCallback();
    if (typeof (runDesign) == "function") runDesign();
  }
}
var getUrl = function (iValue) {
  var value = iValue;
  if (!value) value = window.location.hash;
  var fReturn = { Data: {}, Url: value, Hash: "" };

  if (value) {
    //var fUrl = value.toString();
    if (startsWith(value, '#')) {
      fViewName = value.replace('#', '');
      fReturn.Hash = fViewName;
      if ((fStartParams = fViewName.indexOf("?")) != -1) {
        fReturn.Hash = fViewName.substring(0, fStartParams);
      }
      if ((fStartParams = fViewName.indexOf("/")) != -1) {
        fReturn.Hash = fViewName.substring(0, fStartParams);

        if ((fStartQm = fViewName.indexOf("?")) != -1) {
          fReturn.UID = fViewName.substring((fStartParams + 1), fStartQm);
        }else{
          fReturn.UID = fViewName.substring((fStartParams + 1));
        }
      }
      var fData = "";
      if ((fStartParams = fViewName.indexOf("?")) != -1) {
        try {
          fData = fViewName.substring((fStartParams + 1));
          fData = atob(fData);
          fData = decodeURIComponent(fData);          
          fReturn.Data = JSON.parse(fData);
        } catch (err) {
          fReturn.DataStr = fData;
        }
      }else{
        if(window.location.search){
          var fData = "";
          try {
            fData = window.location.search.substring(1);
            fData = atob(fData);
            fData = decodeURIComponent(fData);          
            fReturn.Data = JSON.parse(fData);
          } catch (err) {
            console.log('Error:', err);
            fReturn.DataStr = fData;
          }
        }    
      }
    }
  }else{
    if(window.location.search){
      var fData = "";
      try {
        fData = window.location.search.substring(1);
        fData = atob(fData);
        fData = decodeURIComponent(fData);          
        fReturn.Data = JSON.parse(fData);
      } catch (err) {
        console.log('Error:', err);
        fReturn.DataStr = fData;
      }
    }
  }

  return fReturn;
}
var setMenuUID = function(iSelf, iForceValue){
  if(iSelf){
    
  }
}
var startsWith = function (iValue, iStartChar) {
  if (typeof (iValue) == "undefined") {
    return false;
  }
  try {
    return iValue.startsWith(iStartChar);
  } catch (err) {
    return (iValue.indexOf(iStartChar) == 0);
  }
}
var cmdEncode = function(iData, iSecured){
  if(iSecured){
    let fData = JSON.stringify(iData);

    fData = unescape(encodeURIComponent(fData));

    return btoa(fData).toString();
  }

  return JSON.stringify(iData);
}
var cmdDecode = function(iData){
  return JSON.parse(iData);
}
var cmdLogin = function (iSelf, iLogin, iCallback, iBehavior) {
  $('.ex-action').prop('disabled', true);
  if (isEcho()) console.log('Sync:', iLogin);
  var fMessage = {
    Action: "Login",
    Name: "LoginStep",
    Payload: JSON.stringify(iLogin)    
  };
  var fUrl = Global.Server.REST;
  if ((Global.Behavior.echoTest) && (Global.Behavior.echoLevel)) {
    //fUrl = fUrl+'?debug='+Global.Behavior.echoLevel;
  }
  if ((iBehavior) && (iBehavior.loading) && (iSelf)) {
    iSelf.set(iBehavior.loading, true);
  }
  $.post(fUrl, fMessage, function (oData) {
    if (isEcho()) console.log('Login end:', oData);

    if (oData.Status) {
      if (oData.Data) {
        oData.Data = JSON.parse(oData.Data);
        setSession({
          "Status": ((oData)&&(oData.Data)&&(oData.Data.UserAuth)&&(oData.Data.UserAuth.toString().toLowerCase() == "true")),
          "Id": oData.Data.SessionId,
          "UID": oData.Data.SessionUID,
          "UserId": oData.Data.UserId,
          "UserUID": oData.Data.UserUID,
          "UserAuth": oData.Data.UserAuth,
          "UserName": oData.Data.UserName,
          "InfoId": oData.Data.InfoId,
          "InfoKey": oData.Data.InfoKey,
          "InfoUID": oData.Data.InfoUID,
          "InfoName": oData.Data.InfoName
        }, iLogin.RememberMe);
      } else {

      }
    }

    if (iSelf) {
      if ((iBehavior) && (iBehavior.loading)) {
        iSelf.set(iBehavior.loading, false);
      }
      if ((iBehavior) && (iBehavior.loadingSoft)) {
        iSelf.set(iBehavior.loadingSoft, false);
      }
    }

    $('.ex-action').prop('disabled', false);
    if (iCallback) {
      iCallback(fMessage, oData);
    }
  }, "json").fail(function () {
    $('.ex-action').prop('disabled', false);
    toastr.error("Error", 'Network error');
    if (iCallback) {
      iCallback(fMessage, undefined);
    }
  });
}
var cmdLoginHelp = function (iSelf, iLogin, iCallback, iBehavior) {

  var fMessage = {
    Action: "LoginHelp",
    Name: "LoginHelp",
    Payload: JSON.stringify(iLogin)    
  };
  setSession(iLogin, false);
  
  if (iCallback) {
    iCallback(fMessage, { Status: true, Data: {}});
  }

  return;
  $('.ex-action').prop('disabled', true);
  if (isEcho()) console.log('Sync:', iLogin);
  var fMessage = {
    Action: "LoginHelp",
    Name: "LoginHelp",
    Payload: JSON.stringify(iLogin)    
  };
  var fUrl = Global.Server.REST;
  if ((Global.Behavior.echoTest) && (Global.Behavior.echoLevel)) {
    //fUrl = fUrl+'?debug='+Global.Behavior.echoLevel;
  }
  if ((iBehavior) && (iBehavior.loading) && (iSelf)) {
    iSelf.set(iBehavior.loading, true);
  }
  $.post(fUrl, fMessage, function (oData) {
    if (isEcho()) console.log('Sync end:', oData);

    if (oData.Status) {
      if (oData.Data) {
        oData.Data = JSON.parse(oData.Data);
        setSession({
          "Status": ((oData)&&(oData.Data)&&(oData.Data.UserAuth)&&(oData.Data.UserAuth.toString().toLowerCase() == "true")),
          "Id": oData.Data.SessionId,
          "UID": oData.Data.SessionUID,
          "UserId": oData.Data.UserId,
          "UserUID": oData.Data.UserUID,
          "UserAuth": oData.Data.UserAuth,
          "UserName": oData.Data.UserName,
          "InfoId": oData.Data.InfoId,
          "InfoKey": oData.Data.InfoKey,
          "InfoUID": oData.Data.InfoUID,
          "InfoName": oData.Data.InfoName,
        }, iLogin.RememberMe);
      } else {

      }
    }

    if (iSelf) {
      if ((iBehavior) && (iBehavior.loading)) {
        iSelf.set(iBehavior.loading, false);
      }
      if ((iBehavior) && (iBehavior.loadingSoft)) {
        iSelf.set(iBehavior.loadingSoft, false);
      }
    }

    $('.ex-action').prop('disabled', false);
    if (iCallback) {
      iCallback(fMessage, oData);
    }
  }, "json").fail(function () {
    $('.ex-action').prop('disabled', false);
    toastr.error("Error", 'Network error');
    if (iCallback) {
      iCallback(fMessage, undefined);
    }
  });
}
var cmdLogout = function (iSelf, iCallback, iBehavior) {
  $('.ex-action').prop('disabled', true);
  if (isEcho()) console.log('Logout:');
  var fMessage = {
    UID: getGuid(),
    Session: cmdEncode(getSession(true)),
    Action: "Logout",
    Name: "Logout",
    Payload: cmdEncode({
      SessionId: Global.Session.Id,
      SessionUID: Global.Session.UID
    })
  };
  var fBehavior = iBehavior;
  var fUrl = Global.Server.REST;
  if ((Global.Behavior.echoTest) && (Global.Behavior.echoLevel)) {
    //fUrl = fUrl+'?debug='+Global.Behavior.echoLevel;
  }
  if (iSelf&&fBehavior) {
    if (fBehavior.loading) {
      iSelf.set(fBehavior.loading, true);
    }
    if (fBehavior.loadingSoft&&fBehavior.Rows) {
      var fRows = iSelf.get(fBehavior.Rows);
      if(fRows&&fRows.length==0){
        iSelf.set(fBehavior.loadingSoft, true);
      }
    }
  }  
  $.post(fUrl, fMessage, function (oData) {
    if (oData && oData.Data) {
      try {
        oData.Data = JSON.parse(oData.Data);
      } catch (err) {
        console.error("Error Json.Data Parse:", err);
      }
    }
    if (oData && oData.Meta) {
      try {
        oData.Meta = JSON.parse(oData.Meta);
      } catch (err) {
        console.error("Error Json.Meta Parse:", err);
      }
    }
    if (isEcho()) console.log('Sync end:', oData);

    if (oData.Status) {
      var fSession = getSessionDef();
      setSession(fSession);
    }

    if (iSelf&&fBehavior) {
      if (fBehavior.loading) {
        iSelf.set(fBehavior.loading, false);
      }
      if (fBehavior.loadingSoft) {
        iSelf.set(fBehavior.loadingSoft, false);
      }
    }

    $('.ex-action').prop('disabled', false);
    if (iCallback) {
      iCallback(oData);
    }
  }, "json").fail(function () {
    $('.ex-action').prop('disabled', false);
    toastr.error("Error", 'Network error');
    if (iCallback) {
      iCallback(fMessage, undefined);
    }
  });
}
var cmdData = function (iSelf, iData, iCallback, iBehavior) {
  $('.ex-action').prop('disabled', true);
  var fBehavior = (iBehavior)? iBehavior: ((iData.Behavior)? iData.Behavior:{});
  var fMessage = {
    UID: getGuid(),
    Session: cmdEncode(getSession(true)),
    Action: (iData.Action)? iData.Action:"",
    Query: (iData.Query)? iData.Query:"",
    Name: iData.Name,
    Payload: cmdEncode(iData.Payload, true),
    Behavior: cmdEncode(fBehavior)
  };
  if(iSelf){
    fMessage.MenuUID = iSelf.get('MenuUID');
  }
  //if (isEcho()) console.log('Data:', iData, fMessage);
  var fUrl = Global.Server.REST;
  if ((Global.Behavior.echoTest) && (Global.Behavior.echoLevel)) {
    //fUrl = fUrl+'?debug='+Global.Behavior.echoLevel;
  }
  if (iSelf&&fBehavior) {
    if (fBehavior.loading) {
      iSelf.set(fBehavior.loading, true);
    }
    if (fBehavior.loadingSoft&&fBehavior.Rows) {
      var fRows = iSelf.get(fBehavior.Rows);
      if(fRows&&fRows.length==0){
        iSelf.set(fBehavior.loadingSoft, true);
      }
    }
  }
  $.post(fUrl, fMessage, function (oData) {
    if (oData && oData.Data) {
      try {
        oData.Data = JSON.parse(oData.Data);
      } catch (err) {
        console.error("Error Json.Data Parse:", err);
      }
    }
    if (oData && oData.Meta) {
      try {
        oData.Meta = JSON.parse(oData.Meta);
      } catch (err) {
        console.error("Error Json.Meta Parse:", err);
      }
    }
    if (isEcho()) console.log('Data Result:', iData, oData);
    if (iSelf&&fBehavior) {
      if (fBehavior.loading) {
        iSelf.set(fBehavior.loading, false);
      }
      if (fBehavior.loadingSoft) {
        iSelf.set(fBehavior.loadingSoft, false);
      }
      if(fBehavior.singleRow){
        if(oData.Data.length){
          oData.Data = oData.Data[0];
        }
      }
      if(fBehavior.JSon){
        let fFields = fBehavior.JSon.split(',');
        if(oData.Data.length){
          for(i=0; i<oData.Data.length; i++){
            for(j=0; j<fFields.length; j++){
              if(oData.Data[i][fFields[j]]){
                try {
                  oData.Data[i][fFields[j]] = JSON.parse(oData.Data[i][fFields[j]]);
                } catch (err) {
                  console.error("Error Json.Data Parse:", err);
                }
              }            
            }  
          }
        }
      }
      if (fBehavior.Rows) {
        if (fBehavior.Key) {
          iSelf.set(fBehavior.Rows, getObject(oData.Data, fBehavior.Key));
        }else{
          iSelf.set(fBehavior.Rows, oData.Data);
        }
      }
      if(fBehavior.Fire){
        iSelf.fire(fBehavior.Fire);
      }
    }
    if(!oData.Status){
      if(toastr){
        let fStr = (iData&&iData.Query)? iData.Query+": ":"";
        toastr.error("Error", fStr + oData.Error);
      }
    }
    $('.ex-action').prop('disabled', false);
    if (iCallback) {
      iCallback(oData);
    }
  }, "json").fail(function () {
    $('.ex-action').prop('disabled', false);
    if (iCallback) {
      iCallback({ Status: false, Error: "Network error!" });
    }else{
      if(toastr){
        toastr.error("Error", 'Network error');
      }
    }
  });
}
var cmdSql = function (iSelf, iData, iCallback, iBehavior) {
  $('.ex-action').prop('disabled', true);
  var fBehavior = (iBehavior)? iBehavior: ((iData.Behavior)? iData.Behavior:{});
  var fMessage = {
    UID: getGuid(),
    Session: cmdEncode(getSession(true)),
    Action: (iData.Action)? iData.Action:"",
    Name: iData.Name,
    Payload: cmdEncode(iData.Payload),
    Behavior: cmdEncode(fBehavior)
  };
  if(iSelf){
    fMessage.MenuUID = iSelf.get('MenuUID');
  }
  if (isEcho()) console.log('Data:', iData, fMessage);
  var fUrl = Global.Server.REST;
  if ((Global.Behavior.echoTest) && (Global.Behavior.echoLevel)) {
    //fUrl = fUrl+'?debug='+Global.Behavior.echoLevel;
  }
  if (iSelf&&fBehavior) {
    if (fBehavior.loading) {
      iSelf.set(fBehavior.loading, true);
    }
    if (fBehavior.loadingSoft&&fBehavior.Rows) {
      var fRows = iSelf.get(fBehavior.Rows);
      if(fRows&&fRows.length==0){
        iSelf.set(fBehavior.loadingSoft, true);
      }
    }
  }
  $.post(fUrl, fMessage, function (oData) {
    if (oData && oData.Data) {
      try {
        oData.Data = JSON.parse(oData.Data);
      } catch (err) {
        console.error("Error Json.Data Parse:", err);
      }
    }
    if (oData && oData.Meta) {
      try {
        oData.Meta = JSON.parse(oData.Meta);
      } catch (err) {
        console.error("Error Json.Meta Parse:", err);
      }
    }
    if (isEcho()) console.log('Data end:', oData);
    if (iSelf&&fBehavior) {
      if (fBehavior.loading) {
        iSelf.set(fBehavior.loading, false);
      }
      if (fBehavior.loadingSoft) {
        iSelf.set(fBehavior.loadingSoft, false);
      }
    }
    $('.ex-action').prop('disabled', false);
    if (iCallback) {
      iCallback(oData);
    }
  }, "json").fail(function () {
    $('.ex-action').prop('disabled', false);
    if (iCallback) {
      iCallback({ Status: false, Error: "Network error!" });
    }else{
      if(toastr){
        toastr.error("Error", 'Network error');
      }
    }
  });
}
var cmdExport = function (iSelf, iData, iCallback, iBehavior) {
  var fBehavior = (iBehavior)? iBehavior: ((iData.Behavior)? iData.Behavior:{});
  var fMessage = {
    UID: getGuid(),
    Session: cmdEncode(getSession(true)),
    Action: (iData.Action)? iData.Action:"",
    Name: iData.Name,
    Payload: cmdEncode(iData.Payload),
    Behavior: cmdEncode(fBehavior)
  };
  if(iSelf){
    fMessage.MenuUID = iSelf.get('MenuUID');
  }
  var fBehavior = (iBehavior)? iBehavior: ((iData.Behavior)? iData.Behavior:{});
  if (isEcho()) console.log('Export:', iData, fMessage);
  var fUrl = Global.Server.REST;
  $.post(fUrl, fMessage, function (oData) {
    if (isEcho()) console.log('Export end:', oData);

    if (iCallback) {
      iCallback(oData);
    }else{
      if(oData.Status){
        var a = $("<a />");
        a.attr("download", oData.Data);
        a.attr("href", oData.Data);
        $("body").append(a);
        a[0].click();
        $("body").remove(a);
      }else{
        toastr.error("Error", oData.Message);
      }
    }
  }).fail(function () {
    $('.ex-action').prop('disabled', false);
    if (iCallback) {
      iCallback({ Status: false, Error: "Network error!" });
    }else{
      if(toastr){
        toastr.error("Error", 'Network error');
      }
    }
  });
}
var setSession = function (iSession, iRemember) {
  if (iSession) {
    if ((typeof (iSession) === "string") && (iSession == "clear")) {
      sessionStorage.clear();
      Global.Session = getSessionDef();

      return true;
    }
    if (typeof (iSession) === "object") {
      var fUser = { 
        InfoKey: iSession.InfoKey,
        UserUID: iSession.UserUID,
        UserAuth: iSession.UserAuth,
        UserName: iSession.UserName
      };
      if(iRemember){
        var fUsers = {};
        if (localStorage.getItem('Users')) {
          fUsers = JSON.parse(localStorage.getItem('Users'));
        }
        if(fUsers&&fUser&&fUser.UserUID){
          fUsers[fUser.UserUID] = fUser;
        }
        localStorage.setItem('Users', JSON.stringify(fUsers));
        if(fUser.InfoKey){
          localStorage.setItem('LastKey', fUser.InfoKey);
        }
      }
      if(Global&&Global.Config&&Global.Config.OneTabOneSession){
        sessionStorage.setItem('User', JSON.stringify(fUser));
        sessionStorage.setItem('Session', JSON.stringify(iSession));
      }else{
        localStorage.setItem('User', JSON.stringify(fUser));
        localStorage.setItem('Session', JSON.stringify(iSession));
      }
    
      Global.Session = iSession;
    }
  } else {
    if(Global&&Global.Config&&Global.Config.OneTabOneSession){
      if (sessionStorage.getItem('Session')) {
        Global.Session = JSON.parse(sessionStorage.getItem('Session'));
      }
    }else{
      if (localStorage.getItem('Session')) {
        Global.Session = JSON.parse(localStorage.getItem('Session'));
      }
    }

    //Global.Session = getSessionDef();
    /*if (sessionStorage.getItem('Session')) {
      Global.Session = JSON.parse(sessionStorage.getItem('Session'));
    } else {
      Global.Session = getSessionDef();
    }*/
  }
}
var getSessionDef = function () {
  var fSession = {
    Status: false,
    Id: 0,
    UID: getGuid(),
    UserId: 0,
    UserUID: "visitor",
    UserAuth: false,
    UserName: "visitor",
    InfoId: 0,
    InfoKey: "",
    InfoUID: "",
    InfoName: "Global Inc."
  };

  return fSession;
}
var getSession = function (iBasic) {
  //ConfigClient.Access.OneTabApp
  var fSession = {};

  if(Global&&Global.Config&&Global.Config.OneTabOneSession){
    if (sessionStorage.getItem('Session')) {
      fSession = JSON.parse(sessionStorage.getItem('Session'));
    }
  }else{
    if (localStorage.getItem('Session')) {
      fSession = JSON.parse(localStorage.getItem('Session'));
    }
  }

  Global.Session = fSession;

  if (iBasic) {
    return {
      Status: fSession.Status,
      Id: fSession.Id,
      UID: fSession.UID,
      UserId: fSession.UserId,
      InfoId: fSession.InfoId
    };
  }

  return fSession;
}
var getUsers = function () {
  if (localStorage.getItem('Users')) {
    return JSON.parse(localStorage.getItem('Users'));
  }

  return [];
}
var cmdRefresh = function () {
  if (Global.Display&&Global.Display.Current) {
    Global.Display.Current.fire('doRefresh');
  }
}
var SyncResult = function (iService, iData) {
  $('.ex-action').prop('disabled', false);
  var componentInstance;
  if ((!componentInstance) && (Global.Callbacks[iService.UID])) {
    componentInstance = Global.Callbacks[iService.UID];
    delete (Global.Callbacks[iService.UID]);
  }

  if ((iData) && (iData.Logout)) {
    cmdLogout();
    return;
  }

  if (iData) {
    if (iData.Status === false) {
      console.log('Error:', iData.Message);
      toastr.error("Greška", 'Greška: ' + iData.Message, { "timeOut": "2500" });
      MessageShow(iData.Message);
    } else {
      if ((iData.Status === true) && (iService.Action == "save")) {
        toastr.success("Uspešno", 'Snimljeno ', { "timeOut": "500" });
        MessageShow("Saved");
      }
      if ((iData.Status === true) && (iService.Action == "delete")) {
        toastr.success("Uspešno", 'Izbrisano ', { "timeOut": "500" });
        MessageShow("Saved");
      }
    }
  }

  if (iService) {

    if (iService.Behavior && iData.Rows) {

      if ((iService.Behavior.Json) && (iData.Rows)) {
        for (i = 0; i < iData.Rows.length; i++) {
          try {
            var fJsons = iService.Behavior.Json.split(",");

            for (jsi = 0; jsi < fJsons.length; jsi++) {
              var fJson = fJsons[jsi];

              if (iData.Rows[i][fJson]) {
                iData.Rows[i][fJson] = JSON.parse(iData.Rows[i][fJson]);
              }
            }

          } catch (err) {

          }
        }
      }
      if (iService.Behavior.singleRow) {
        for (var key in iData.Rows) {
          iData.Rows = iData.Rows[key];
          break;
        }
      }
      if (iService.Behavior.orderby) {
        iData.Rows = getSortBy(iData.Rows, iService.Behavior.orderby, iService.Behavior.orderdesc);
      }
      if (iService.Behavior.Key) {
        iData.Rows = getObject(iData.Rows, iService.Behavior.Key);
      }
    }

    if (componentInstance && iService.Behavior && iService.Behavior.loading) {
      componentInstance.set(iService.Behavior.loading, false);
    }
    if (componentInstance && iService.Behavior && iService.Behavior.loadingSoft) {
      componentInstance.set(iService.Behavior.loadingSoft, false);
    }
  }
  if (isEcho()) console.log('Sync result:', iService, iData);
  if (componentInstance && iData.Rows) {
    if (iService && iService.Action == "detail" && iService.Item) {
      componentInstance.set(iService.Item, iData.Rows[0]);
    } else {
      componentInstance.set(iService.Rows, iData.Rows);
      if (iService.Rows.indexOf('CacheData.') == 0) {
        setCache(iService, iData.Rows);
      }
    }
  }
  if (iService && iService.Behavior && iService.Behavior.Fire) {
    componentInstance.fire(iService.Behavior.Fire, iService, iData);
  }
  if (iService.Meta && iData.Meta) {
    componentInstance.set(iService.Meta, iData.Meta);
  }
  if ((iData.Behavior) && (iData.Behavior.rootRefresh) && (Global.Display.Root)) {
    Global.Display.Root.fire('doRefresh');
  }
  if ((iData.Behavior) && (iData.Behavior.frameRefresh) && (Global.Display.Current)) {
    Global.Display.Current.fire('doRefresh');
  }
}
var cmdEvent = function (iEvent, iCallback) {
}
var cmdValidate = function(iMeta, iRow, iShow){
  if (isEcho()) console.log("Validate:", iMeta, iRow);

  try{
    if(iRow&&iMeta){
      var fFaild = 0;
      var fFaildFields = "";
      for(var fIdx in iMeta.Columns){
        if(iMeta.Columns[fIdx].DetailMandatory&&!iMeta.Columns[fIdx].FilterParam){
          var fValue = (iRow[iMeta.Columns[fIdx].Name])? iRow[iMeta.Columns[fIdx].Name]: "";
          if(fValue){
            if(iMeta.Columns[fIdx].MandatoryRegEx){
              var fRegEx = iMeta.Columns[fIdx].MandatoryRegEx;
              if(!fRegEx.test(fValue)){
                
              }
            }  
          }else{
            fFaild++;
            fFaildFields += "<b>" + iMeta.Columns[fIdx].Caption + "</b> nema vrednost [" + iMeta.Columns[fIdx].Name + "]<br>";
          }
        }
      }
      if((0<fFaild)&&(iShow)){
        toastr.error(fFaildFields, "Proverite podatke!");
      }

      return (fFaild==0);
    }
  }catch(err){
    console.log("Error: cmdValidate-", err);
  }

  return true;
}
var setCache = function (iService, iData) {
  var fCacheData = {};
  var key;

  if (localStorage.getItem('storageU')) {
    try {
      fCacheData = JSON.parse(localStorage.getItem('storageU'));
    } catch (ex) {
      localStorage.clear();
    }
  }

  if (iService.Name) key = iService.Name;
  if (typeof (iService) == "string") key = iService;
  if ((iService.Behavior) && (iService.Behavior.CacheKey)) key = key + iService.Behavior.CacheKey;

  if ((key) && (key != "")) {
    fCacheData[key] = iData;
    localStorage.setItem('storageU', JSON.stringify(fCacheData));
  }
}
var getCache = function (iService, iDefault) {
  var key;
  if (iService.Name) key = iService.Name;
  if (typeof (iService) == "string") key = iService;
  if ((iService.Behavior) && (iService.Behavior.CacheKey)) key = key + iService.Behavior.CacheKey;

  if ((key) && (key != "") && (localStorage.getItem('storageU'))) {
    var fCacheData = JSON.parse(localStorage.getItem('storageU'));
    if ((fCacheData) && typeof (fCacheData[key]) !== "undefined") {
      return fCacheData[key];
    }
  }

  return iDefault;
}
var cmdModalShow = function (iId) {
  if($(iId)){
    $(iId).modal('show');
  }
}
var MessageShow = function (iMessage, iFullName, iProfilePicture) {
/*
      toastr.error("Greška", 'Greška: ' + iData.Message, { "timeOut": "2500" });
      MessageShow(iData.Message);
    } else {
      if ((iData.Status === true) && (iService.Action == "save")) {
        toastr.success("Uspešno", 'Snimljeno ', { "timeOut": "500" });
        MessageShow("Saved");
      }
      if ((iData.Status === true) && (iService.Action == "delete")) {
        toastr.success("Uspešno", 'Izbrisano ', { "timeOut": "500" });
*/
  var fMessageText = '';
  var fMessageTitle = '';
  var fMessagePicture = '';

  if (iMessage && iMessage.Text)
    fMessageText = iMessage.Text;

  if (iMessage && iMessage.Type)
    fMessageTitle = iMessage.Type;

  if (!("Notification" in window)) {
    console.log("This browser does not support desktop notification!");
  }
  else if (Notification.permission === "granted") {
    var options = {
      body: fMessageText,
      icon: fMessagePicture,
      requireInteraction: true
    }
    var notification = new Notification(fMessageTitle, options);
    setTimeout(notification.close.bind(notification), 15000);
  }
  else if (Notification.permission !== 'denied') {
    Notification.requestPermission(function (permission) {
      if (permission === "granted") {
        var notification = new Notification(fMessageText);
      }
    });
  }
}
var isEcho = function (iLevel) {
  if ((Global) && (Global.Behavior) && (Global.Behavior.echoTest)) {
    if ((Global) && (Global.Behavior) && (Global.Behavior.echoLevel) && (iLevel) && (Global.Behavior.echoLevel <= iLevel)) {
      return false;
    }
    return true;
  }

  return false;
}
var cmdNewRow = function (iObjectType) {
  var fRow = {};
  //fRow.ObjectUID =  
  return fRow;
};
var getGuid = function () {
  var d = new Date().getTime();
  if (window.performance && typeof window.performance.now === "function") {
    d += performance.now(); //use high-precision timer if available
  }
  /*var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });*/
  var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });  
  return uuid;
}
var getShort = function (iLength, iLetters) {
  if (!iLength) iLength = 4;
  var text = "";
  var allPos = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var ltrPos = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  var possible = allPos;
  if (typeof (iLetters) == "string") {
    possible = iLetters;
  }
  if ((typeof (iLetters) == "boolean") && (iLetters === true)) {
    possible = ltrPos;
  }

  for (var i = 0; i < iLength; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}
var getPin = function (iLength) {
  if (!iLength) iLength = 4;
  var text = "";
  var possible = "0123456789";

  for (var i = 0; i < iLength; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}
var getClone = function (obj) {
  if (null == obj || "object" != typeof obj) return obj;
  var copy = obj.constructor();
  for (var attr in obj) {
    if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
  }
  return copy;
}
var getTemplate = function (iObj, iTemplate) {
  let fObj = iObj;
  
  if(iObj&&iTemplate){
    for(var fKey in iTemplate){
      if(typeof(iObj[fKey])==='undefined'){
        iObj[fKey] = iTemplate[fKey];
      }
    }
  }

  return fObj;
}
var getSortBy = function (iData, field, reverse, primer) {

  var fData = [];
  var fKeepProp = false;
  if (Array.isArray(iData)) {
    fData = iData;
  } else {
    for (var key in iData) {
      fData.push(iData[key]);
      fKeepProp = true;
    }
  }

  reverse = !reverse ? 1 : -1;
  var key = primer ?
    function (x) { return primer(x[field]) } :
    function (x) { return x[field] };

  fData.sort(function (a, b) {
    var a = key(a);//.ChangeDate;
    var b = key(b);//.ChangeDate;
    return reverse * ((a > b) - (b > a));
  });

  if (fKeepProp) {
    var fTemp = {};
    for (i = 0; i < fData.length; i++) {
      //fTemp[fData[i].PageUID] = fData[i]; 
    }

    //fData = fTemp;
  }

  return fData;
}
var getArray = function (iValue) {
  var fResult = [];

  if (Array.isArray(iValue)) {
    return iValue
  }
  if (typeof (iValue) == 'string') {
    return iValue;
  }
  if (typeof (iValue) == 'object') {
    var fResult = [];
    for (var key in iValue) {
      fResult.push(iValue[key]);
    }
    return fResult;
  }

  return [];
}
var getObject = function (iValue, iKey) {

  if (Array.isArray(iValue)) {
    var fResult = {};

    for (i = 0; i < iValue.length; i++) {
      var fKey = iValue[i][iKey];
      fResult[fKey] = iValue[i];
    }

    return fResult;
  }

  return iValue;
}
var getObjectParam = function (iValue) {
  var fResult = {};

  if(iValue){
    var s1 = iValue.split(';');
    for (i = 0; i < s1.length; i++) {
      var s1Line = s1[i];
      if(s1Line){
        var s2 = s1Line.split('=');
        var s2Key = (s2&&0<s2.length)? s2[0].toString().toLowerCase().trim():"";
        var s2Value = (s2&&1<s2.length)? s2[1]:"";
        if(s2Key){
          fResult[s2Key] = s2Value;
        }
      }
    }
  }

  return fResult;
}
var getObjectAction = function (iValue) {
  var fResult = {};

  if(iValue){
    var s1 = iValue.split(';');
    for (i = 0; i < s1.length; i++) {
      var s1Line = s1[i];
      if(s1Line){
        var s2 = s1Line.split('=');
        var s2Key = (s2&&0<s2.length)? s2[0].toString().toLowerCase().trim():"";
        var s2Value = (s2&&1<s2.length)? s2[1]:"";
        if(s2Key){
          fResult[s2Key] = s2Value;
        }
      }
    }
  }

  return fResult;
}
var mergeArray = function (iA, iB) {
  var fResult = iA;
  try {
    fResult = Object.assign(iA, iB);
  } catch (err) {
    for (var key in iB) {
      iA[key] = iB[key];
    }
  }

  return fResult;
}
var getMerge = function (iA1, iA2, iA3) {
  var fResult = {};

  if (typeof (iA1) == 'object') {
    fResult = mergeArray(fResult, iA1);
  }

  if (typeof (iA2) == 'object') {
    fResult = mergeArray(fResult, iA2);
  }

  if (typeof (iA3) == 'object') {
    fResult = mergeArray(fResult, iA3);
  }

  return fResult;
}
var setCmd = function (iAction, iData) {
  console.log('setCmd', iAction, iData);
  switch (iAction) {
    case "doPrint":
      window.print();
      break;
    case "doBack":
      if (1 < history.length) {
        window.history.back();
      } else {
        window.close();
        window.open('', '_self').close();
      }
      break;
    case "setUrl":
      setUrl(iData);
      break;
    default:
      if ((Global) && (Global.Display)) {
        Global.Display.Root.fire('doCmd', iAction, iData);
      }
      break;
  }
}
var getSrv = function (iName, iDefault) {
  if (iName.toString().indexOf(',') != -1) {
    var fResult = {};
    var fSrvs = iName.toString().split(',');
    for (var fIndex in fSrvs) {
      if ((fItem = fSrvs[fIndex]) && SiteLng && SiteLng.Meta && SiteLng.Meta[fItem] && SiteLng.Meta[fItem].Srv) {
        fResult[fItem] = SiteLng.Meta[fItem].Srv;
      }
    }

    if (Definitions && Definitions.getSrv(iName)) {
      return Definitions.getSrv(iName);
    }

    return fResult;
  }

  if (SiteLng && SiteLng.Meta && SiteLng.Meta[iName] && SiteLng.Meta[iName].Srv) {
    return SiteLng.Meta[iName].Srv;
  }

  if (Definitions && Definitions.getSrv(iName)) {
    return Definitions.getSrv(iName);
  }

  return iDefault;
}
var getDefaultValue = function(iValue, iDefault){
  if(iValue){
    switch(iValue.toString().toLowerCase()){
      case "now":
        break;
      case "timenow":
        break;
      case "datenow":
        return Client.getDateYYYMMDD();
      case "monthnow":
        var d = new Date();
        return (d.getMonth() + 1);
      case "yearnow":
        var d = new Date();
        return d.getFullYear();
      case "datel":
        break;
      case "dater":
        break;
    }

    return iValue;
  }

  return (iDefault? iDefault:"");
}
var getFilter = function(iSelf, iDefault){
  if(iSelf){
    var fMenuUID = iSelf.get("MenuUID");
    if(fMenuUID){      
      var fFilter = {};
      var fFilterMeta = iSelf.get("Meta.Filter")? iSelf.get("Meta.Filter"):{};
      var fFilterCache;

      for(i=0; i<fFilterMeta.length; i++){
        if(fFilterMeta[i].FilterParam){
          var fFilterValue = Client.getDefaultValue(fFilterMeta[i].FilterValue);

          fFilter[fFilterMeta[i].FilterParam] = {
            Name: fFilterMeta[i].FilterParam,
            Value: fFilterValue,
            Meta: fFilterMeta[i]
          }
        }
      }

      let fName = ((Global&&Global.Session&&Global.Session.UserId)? Global.Session.UserId:'')+'Filters';
      var fFilterCaches = Client.getCache(fName, {});
      if(fFilterCaches[fMenuUID]){ 
        fFilterCache = fFilterCaches[fMenuUID];
        
        for(var fParamName in fFilterCache){
          if(fParamName){
            if(fFilter[fParamName]){
              if(fFilter[fParamName].Value&&fFilterCache[fParamName].Value){
                fFilter[fParamName].Value = fFilterCache[fParamName].Value;
              }
            }else{
              fFilter[fParamName] = fFilterCache[fParamName];
            }
          }
        }        
      }
      
      if(iDefault){
        for(var fParamName in iDefault){
          if(fFilter[fParamName]&&iDefault[fParamName].Value){
            fFilter[fParamName].Value = iDefault[fParamName].Value;
          }
        }
      }

      return fFilter;
    }
  }
  
  return iDefault;
}
var setFilterCache = function(iSelf, iFilter){
  if(iSelf&&iFilter){
    var fMenuUID = iSelf.get("MenuUID");
    
    if(fMenuUID){
      let fName = ((Global&&Global.Session&&Global.Session.UserId)? Global.Session.UserId:'')+'Filters';
      var fFilterCache = Client.getCache(fName, {});      
      fFilterCache[fMenuUID] = iFilter;
      Client.setCache(fName, fFilterCache);
    }
  }
}
var getFilterPlane = function(iSelf, iDefault){
  if(iSelf){
    var fMenuUID = iSelf.get("MenuUID");
    if(fMenuUID){
      var fFilter = (iDefault)? iDefault:{};
      let fName = 'FiltersPlane'+((Global&&Global.Session&&Global.Session.UserId)? Global.Session.UserId:'');
      var fFilterCaches = Client.getCache(fName, {});

      if(fFilterCaches[fMenuUID]){ 
        let fFilterCache = fFilterCaches[fMenuUID];
        
        for(var fParamName in fFilter){
          if(fFilterCache[fParamName]){
            fFilter[fParamName] = fFilterCache[fParamName];
          }
        }
      }
      
      return fFilter;
    }
  }
  
  return iDefault;
}
var setFilterPlane = function(iSelf, iFilter){
  if(iSelf&&iFilter){
    const fMenuUID = iSelf.get("MenuUID");
    
    if(fMenuUID){
      let fName = 'FiltersPlane'+((Global&&Global.Session&&Global.Session.UserId)? Global.Session.UserId:'');
      let fFilterCache = Client.getCache(fName, {});      
      fFilterCache[fMenuUID] = iFilter;
      Client.setCache(fName, fFilterCache);
    }
  }
}
var getNow = function () {
  var fNow = (new Date());
  const offset = fNow.getTimezoneOffset()
  fNow = new Date(fNow.getTime() - (offset * 60 * 1000));

  return fNow.toISOString().substring(0, 19).replace('T', ' ');
}
var getDateYYYMMDD = function (iValue) {
  var d = (iValue)? new Date(iValue):new Date(),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) 
    month = '0' + month;
  if (day.length < 2) 
    day = '0' + day;

  return [year, month, day].join('-');
}
var getDateYYYMMDDMin = function (iYear, iMonth) {
  var fDate = new Date(); 
  if(iMonth==0){
    fDate = new Date(iYear-1, 11, 1); 
  }else{
    fDate = new Date(iYear, iMonth-1, 1);        
  }

  //return fDate.toISOString().split('T')[0];
  let month = '' + (fDate.getMonth() + 1),
  day = '' + fDate.getDate(),
  year = fDate.getFullYear();

  if (month.length < 2) 
    month = '0' + month;
  if (day.length < 2) 
    day = '0' + day;

  return [year, month, day].join('-');  
}
var getDateYYYMMDDMax = function (iYear, iMonth) {
  var fDate = new Date(); 
  if(iMonth==12){
    fDate = new Date(iYear+1, 0, 0); 
  }else{
    fDate = new Date(iYear, iMonth, 0); 
  }
  let month = '' + (fDate.getMonth() + 1),
  day = '' + fDate.getDate(),
  year = fDate.getFullYear();

  if (month.length < 2) 
    month = '0' + month;
  if (day.length < 2) 
    day = '0' + day;

  return [year, month, day].join('-');  
}
var getDateMinAdd = function (iValue, iMinutes) {
  if(iValue){
    let fDateOld = new Date(iValue);
    let fDate = new Date(fDateOld.getTime() + (iMinutes*60000));
    const date = fDate.toISOString().split('T')[0];
    const time = fDate.toTimeString().split(' ')[0];
    return date+"T"+time;
    return fDate.toISOString();
  }

  return iValue;
}
var getDateMinDiff = function (iStart, iEnd) {
  if(iStart&&iEnd){
    let fStart = new Date(iStart).getTime();
    let fEnd = new Date(iEnd).getTime();
    return Math.round((fEnd - fStart) / 60000);
  }

  return 0;
}
var getDateDayAdd = function (iValue, iDays) {
  if(iValue&&iDays){
    let fDate = new Date(iValue);
    fDate.setDate(fDate.getDate() + iDays);

    //return fDate.toISOString().substring(0, 10);

    let month = '' + (fDate.getMonth() + 1), day = '' + fDate.getDate(), year = fDate.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');    
  }

  return iValue;
}
var getDateHour = function (iValue, iDefault) {
  if(iValue){
    let fDate = new Date(iValue);

    return fDate.getHours();
  }

  return iDefault;
}
var getDatePresek = function (iRow, iSmena, iDate, iNonWork) {
  if(iRow&&iSmena&&iSmena.presek&&iSmena.presek==1){
    iRow.presek = true;
    if(Client.isEcho()) console.log('getDatePresek:', iRow, iSmena);
    let fPocelo = iSmena.pocelo;
    let fZavrseno = iSmena.zavrseno;
    let fDataSub = [];
    let fDateIndex = (iDate)? new Date(iDate).getDay():false;
    let fIsDateNed = (iDate)? ((new Date(iDate)).getDay()==0):false;
    let fIsDateNedSutra = (iDate)? ((new Date(iDate)).getDay()==6):false;
    
    if(Client.getDateHour(fPocelo)<22){
      iRow.pocelo = iSmena.pocelo;
      iRow.zavrseno = "1900-01-01T22:00:00";
      iRow.aktivnomin = Client.getDateMinDiff(iRow.pocelo, iRow.zavrseno);
      iRow.sekvenca = Client.getDateHour(fPocelo);
      iRow.DateEndBlock = true;

      fVrsta = 11;//iRow.vrsta;
      if(fIsDateNed){
        fVrsta = 103;//-RN RAD NEDELJOM
      }  

      fDataSub.push(
        {
          vrsta: fVrsta,
          smena: iRow.smena,
          napomena: "",
          pocelo: "1900-01-01T22:00:00",
          zavrseno: "1900-01-01T23:59:59",
          aktivnomin: (2*60),
          sekvenca: Client.getDateHour(fPocelo),
          DateSame:  true,
          DateStartBlock: true,
          DateEndBlock: true
        }
      );
    }else{
      iRow.pocelo = iSmena.pocelo;
      iRow.zavrseno = "1900-01-01T23:59:59";
      iRow.aktivnomin = Client.getDateMinDiff(iRow.pocelo, "1900-01-01T23:59:59");
      iRow.sekvenca = Client.getDateHour(fPocelo);
      iRow.DateEndBlock = true;
    }

    if(6<Client.getDateHour(fZavrseno)){
      
      let fVrsta = 11;
      if(fIsDateNedSutra){
        fVrsta = 103;//-RN RAD NEDELJOM
      }            
      if(iNonWork&&iDate){
        let fDateYMD = Client.getDateDayAdd(iDate, 1)+"T00:00:00";
        if(iNonWork[fDateYMD]){
          fVrsta = 16;//-RD RAD NA DRŽAVNI I VER.PRAZ.
        }
      }

      fDataSub.push(
        {
          vrsta: fVrsta,
          smena: iRow.smena,
          napomena: "",
          pocelo: "1900-01-01T00:00:00",
          zavrseno: "1900-01-01T06:00:00",
          aktivnomin: Client.getDateMinDiff("1900-01-01T00:00:00", "1900-01-01T06:00:00"),
          sekvenca: Client.getDateHour(fPocelo),
          DateStartBlock: true,
          DateEndBlock: true
        }
      );
      
      fVrsta = iRow.vrsta;
      if(fIsDateNedSutra){
        fVrsta = 103;//-RN RAD NEDELJOM
      }else{
        if(fVrsta==103){
          fVrsta = 1;
        }
      }            
      if(iNonWork&&iDate){
        let fDateYMD = Client.getDateDayAdd(iDate, 1)+"T00:00:00";
        if(iNonWork[fDateYMD]){
          fVrsta = 16;//-RD RAD NA DRŽAVNI I VER.PRAZ.
        }
      }

      fDataSub.push(
        {
          vrsta: fVrsta,
          smena: iRow.smena,
          napomena: "",
          pocelo: "1900-01-01T06:00:00",
          zavrseno: fZavrseno,
          aktivnomin: Client.getDateMinDiff("1900-01-01T06:00:00", fZavrseno),
          sekvenca: Client.getDateHour(fPocelo),
          DateStartBlock: true
        }
      );
    }else{

      let fVrsta = 11;
      if(fIsDateNedSutra){
        fVrsta = 103;//-RN RAD NEDELJOM
      }            
      if(iNonWork&&iDate){
        let fDateYMD = Client.getDateDayAdd(iDate, 1)+"T00:00:00";
        if(iNonWork[fDateYMD]){
          fVrsta = 16;//-RD RAD NA DRŽAVNI I VER.PRAZ.
        }
      }

      fDataSub.push(
        {
          vrsta: fVrsta,
          smena: iRow.smena,
          napomena: "",
          pocelo: "1900-01-01T00:00:00",
          zavrseno: fZavrseno,
          aktivnomin: Client.getDateMinDiff("1900-01-01T00:00:00", fZavrseno),
          DateStartBlock: true,
          DateEndBlock: false          
        }
      );
    }
    iRow.Sub = fDataSub;    
  }else{
    if(fSmena.pocelo){
      iRow.pocelo = fSmena.pocelo;
    }
    if(fSmena.zavrseno){
      iRow.zavrseno = fSmena.zavrseno;
    }
    iRow.aktivnomin = fSmena.aktivnomin;
    iRow.presek = false;
    iRow.Sub = [];
  }

  if(Client.isEcho()) console.log('getDatePresek:', iRow);
  return iRow;
}
var getDateSekvenca = function(iDate, iIndex){
  let fReturn = 0;

  if(iDate){
    try {
      let fDate = new Date(iDate);
      fReturn = fDate.getDate()*100;
    } catch (err) {
      console.error("Error Sekvenca:", err);
    }
  }

  if(iIndex){
    fReturn += iIndex;
  }

  return fReturn;
}

module.exports.MessageShow = MessageShow;
module.exports.ModalShow = cmdModalShow;
module.exports.cmdNewRow = cmdNewRow;
module.exports.cmdRefresh = cmdRefresh;
module.exports.setSession = setSession;
module.exports.getSession = getSession;
module.exports.getUsers = getUsers;
module.exports.getPin = getPin;
module.exports.getGuid = getGuid;
module.exports.getShort = getShort;
module.exports.getNow = getNow;
module.exports.getDateYYYMMDD = getDateYYYMMDD;
module.exports.getDateYYYMMDDMin = getDateYYYMMDDMin;
module.exports.getDateYYYMMDDMax = getDateYYYMMDDMax;
module.exports.getDateMinAdd = getDateMinAdd;
module.exports.getDateMinDiff = getDateMinDiff;
module.exports.getDateDayAdd = getDateDayAdd;
module.exports.getDateHour = getDateHour;
module.exports.getDatePresek = getDatePresek;
module.exports.getDateSekvenca = getDateSekvenca;
module.exports.getSrv = getSrv;
module.exports.getFilter = getFilter;
module.exports.getFilterPlane = getFilterPlane;
module.exports.setFilterPlane = setFilterPlane;
module.exports.getDefaultValue = getDefaultValue;
module.exports.setFilterCache = setFilterCache;
module.exports.getBase64 = getBase64;
module.exports.getClone = getClone;
module.exports.getTemplate = getTemplate;
module.exports.setDisplay = setDisplay;
module.exports.createDisplay = createDisplay;
module.exports.getSortBy = getSortBy;
module.exports.getConfig = getConfig;
module.exports.isEcho = isEcho;
module.exports.setCache = setCache;
module.exports.getCache = getCache;
module.exports.getMerge = getMerge;
module.exports.SyncResult = SyncResult;
module.exports.SyncDisplay = setDisplay;
module.exports.SyncUrl = setUrl;
module.exports.Sync = {
  Session: setSession,
  Url: setUrl
}
module.exports.Cmd = {
  Login: cmdLogin,
  LoginHelp: cmdLoginHelp,
  Logout: cmdLogout,
  IsValid: getIsValid,
  Action: cmdData,
  Data: cmdData,
  Sql: cmdSql,
  Export: cmdExport,
  Event: cmdEvent,
  Validate: cmdValidate
}
module.exports.setUrl = setUrl;
module.exports.setUrlChange = setUrlChange;
module.exports.getUrl = getUrl;
module.exports.goUrl = goUrl;
module.exports.getGlobal = getGlobal;
module.exports.getArray = getArray;
module.exports.getObject = getObject;
module.exports.getObjectParam = getObjectParam;
module.exports.startsWith = startsWith;
module.exports.setCmd = setCmd;
module.exports.setMenuUID = setMenuUID;
module.exports.getMeta = function(iSelf, iUID){
  if((iSelf)&&(iUID)&&(Window.nteforms)){
    if(Window.nteforms[iUID]){
      iSelf.set('Meta.MenuCaption', Window.nteforms[iUID].MenuCaption);
      iSelf.set('Meta.Caption', Window.nteforms[iUID].Caption);
    }    
  }
}
module.exports.setMeta = function(iSelf, iUID){
  if(!Window.nteforms){
    Window.nteforms = { };
  }	  
  if((iSelf)&&(iUID)&&(Window.nteforms)){
    Window.nteforms[iUID] = {
      MenuCaption: iSelf.get('Meta.MenuCaption'),
      Caption: iSelf.get('Meta.Caption')
    };
  }
}
module.exports.setMetaInfo = function(iSelf, iMeta){
  window.onkeyup = function (event) {   
    //if (Client.isEcho()) console.log("Key event:", event.ctrlKey, event.key, event.keyCode);
    if (event.ctrlKey && event.keyCode == 77) {
      if (Client.isEcho()&&iSelf) console.log("Meta:", iSelf.get('Meta'));

      const screenshotTarget = document.body;

      try
      {
        if(screenshotTarget&&html2canvas){
          html2canvas(screenshotTarget).then((canvas) => {
            const base64image = canvas.toDataURL("image/png");
            Global.lastImg = base64image;
            document.getElementById('helpimg').src = base64image;
            //window.location.href = base64image;
          });
        }  
      }
      catch(err)
      {
        console.log("Error: cmdMeta-", err);
      }
      Client.ModalShow("#MetaShow");
    }
  }
}
module.exports.setMetaCache = function(iSelf, iMeta){
  if(iSelf&&iMeta){
    var fMenuUID = iSelf.get("MenuUID");
    if(fMenuUID){
      var fMetasCache = Client.getCache('Metas', {});      
      fMetasCache[fMenuUID] = {
        MaxRecords: iMeta.MaxRecords,
        Columns: {}
      };
      for(var fIdx in iMeta.Columns){
        var fName = iMeta.Columns[fIdx].Name;
        var fVisible = iMeta.Columns[fIdx].ListVisible;
        fMetasCache[fMenuUID].Columns[fName] = fVisible;
      }

      Client.setCache('Metas', fMetasCache);
    }
  }
}
module.exports.getMetaCache = function(iSelf, iMeta){
  if (Client.isEcho()) console.log('Meta get:', iMeta);
  if(iSelf&&iMeta){
    var fMenuUID = iSelf.get("MenuUID");
    if(fMenuUID){
      var fMetasCache = Client.getCache('Metas', {});      
      if(fMetasCache[fMenuUID]){
        var fMeta = fMetasCache[fMenuUID];
        iMeta.MaxRecords = fMeta.MaxRecords;

        if(iMeta.Columns&&fMeta.Columns){
          for(var fIdx in iMeta.Columns){
            if(iMeta.Columns[fIdx].Name&&(typeof(fMeta.Columns[iMeta.Columns[fIdx].Name])!=="undefined")){
              iMeta.Columns[fIdx].ListVisible = fMeta.Columns[iMeta.Columns[fIdx].Name];
            }
          }  
        }
      };
    }
  }

  return iMeta;
}
module.exports.getKeyValue = function(iArr, iFieldKey, iValue, iFieldReturn, iDefault){
  if(iArr&&iFieldKey&&iFieldReturn){
    for(i=0; i<iArr.length; i++){
      if(iArr[i]&&iArr[i][iFieldKey]&&iArr[i][iFieldKey]==iValue){
        return iArr[i][iFieldReturn];
      }
    }
  }

  return (iDefault)? iDefault:iValue;
}
module.exports.getLastUserKey = function(){
  let fUserKey = "";

  if (fUserKey = localStorage.getItem('LastKey')) {
    return fUserKey;
  }

  return fUserKey;
}
module.exports.setFocus = function(iId){
  try
  {
    if(iId&&document.getElementById(iId)){
      document.getElementById(iId).focus();
    }
  }
  catch(err)
  {

  }
}



//////////////////
// WEBPACK FOOTER
// ./ractive/Project/ERP/client.js
// module id = 12
// module chunks = 0